import IsuseInvoiceHandle from '@/pages/handle/isuseInvoiceHandle'
import IssueInvoiceDetail from '@/pages/handle/isuseInvoiceHandle/invoiceDetail'
import IssueInvoiceDetailOrderDetail from '@/pages/orderManage/agOrderList/OrderDetail'

export default [
  {
    path: '/isuseInvoiceHandle',
    name: 'IsuseInvoiceHandle',
    component: IsuseInvoiceHandle,
    meta: { name: '开票处理' }
  },
  {
    path: '/isuseInvoiceHandle/issueInvoiceDetail/:orderId',
    name: 'IssueInvoiceDetail',
    component: IssueInvoiceDetail,
    props: true,
    meta: { name: ['开票处理', '发票详情'] }
  },
  {
    path: '/isuseInvoiceHandle/issueInvoiceDetail/orderDetail/:orderId',
    name: 'IssueInvoiceDetailOrderDetail',
    component: IssueInvoiceDetailOrderDetail,
    props: true,
    meta: { name: ['开票处理', '发票详情', '工单详情'] }
  }
]



// WEBPACK FOOTER //
// ./src/router/handle/issueInvoiceHandle.js